// extracted by mini-css-extract-plugin
export default {"container":"ProfileSettings_container__VULzI","main":"ProfileSettings_main__FuGCi","navigationItem":"ProfileSettings_navigationItem__U9qbi"};